import { addNewUserRecord } from "../../user_records/UserRecordsAPI";
import { RecordMetadataEnum, ReportingSystemSomaWeb } from "../../user_records/UserRecordsModels";

//todo: create user records through BFF https://solargik.atlassian.net/browse/C9-2632

export const createUserSafeActionUserRecord = async (
  siteId: string,
  userName: string,
  activate: boolean,
  reason?: string
) => {
  const reasonSuffix = reason ? ` (${reason})` : "";
  const userRecordDto = {
    EventDate: Date.now(),
    Title: activate ? "Safe mode activated" : "Safe mode deactivated",
    Reporter: userName,
    ComponentType: "System",
    ComponentName: "-",
    Description: activate
      ? `Site sent to safe mode by the user${reasonSuffix}`
      : "Site released from safe mode by the user",
    IsEngineerOnly: false,
    ReportingSystem: ReportingSystemSomaWeb,
    RecordMetadata: activate
      ? RecordMetadataEnum.SystemSafetyEnabled
      : RecordMetadataEnum.SystemSafetyDisabled,
  };
  await addNewUserRecord(siteId, userRecordDto);
};
